module.exports = __webpack_public_path__ + "img/interruptor_de_seguridad.71cab5ed.jpg";